<div class="modal-header-modern">
  <div class="modal-header-icon icon-blue">
    <i class="material-icons">description</i>
  </div>
  <div>
    <h4 class="modal-title-modern">{{ evolucaoId ? 'Editar Evolução' : 'Nova Evolução' }}</h4>
    <p class="modal-subtitle-modern">Registre as anotações e observações do atendimento</p>
  </div>
  <button type="button" class="modal-close-btn" aria-label="Close" (click)="cancelar()">
    <i class="material-icons">close</i>
  </button>
</div>
<div class="modal-body">
  <div class="container-fluid px-0">
    <form [formGroup]="evolucaoForm">
      <div class="row">
        <mat-form-field class="col-12 col-lg-8" appearance="outline">
          <mat-label>Título</mat-label>
          <input matInput formControlName="titulo" required placeholder="Ex: Sessão de acompanhamento" maxlength="200" />
        </mat-form-field>
        <mat-form-field class="col-12 col-lg-4" appearance="outline">
          <mat-label>Data e Hora</mat-label>
          <input matInput type="datetime-local" formControlName="dataCriacao" />
        </mat-form-field>
      </div>

      <div class="row">
        <div class="col-12">
          <label class="editor-label">Conteúdo da Evolução</label>
          <quill-editor
            formControlName="conteudo"
            [modules]="quillModules"
            [styles]="{ height: '250px', width: '100%' }"
            placeholder="Descreva a evolução do paciente..."
            [readOnly]="somenteLeitura">
          </quill-editor>
        </div>
      </div>

      <ngx-loading [show]="loading"></ngx-loading>
    </form>
  </div>
</div>

<div class="modal-footer-modern">
  <button type="button" class="btn-modern btn-modern-outline" (click)="cancelar()">
    <i class="material-icons">close</i> Cancelar
  </button>
  <button *ngIf="!somenteLeitura" type="button" class="btn-modern btn-modern-success" (click)="confirmar()">
    <i class="material-icons">check</i> Confirmar
  </button>
</div>
